import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
export default class UITypeaheadResults extends PureComponent {
  render() {
    const _this$props = this.props,
          {
      children,
      className,
      onScroll
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "onScroll"]);

    return /*#__PURE__*/_jsx("ul", Object.assign({}, rest, {
      className: classNames('private-typeahead-results', className),
      onScroll: onScroll,
      role: "listbox",
      children: children
    }));
  }

}
UITypeaheadResults.propTypes = {
  children: PropTypes.node,
  onScroll: PropTypes.func
};
UITypeaheadResults.displayName = 'UITypeaheadResults';